import React from "react";
import { AiOutlineBarcode } from "react-icons/ai";
import { FiArrowRight } from "react-icons/fi";
import OpenVendingModal from "../modals/guest/open-vending-modal";
import { DEFAULT_CHARGES, MIN_AMOUNT } from "../../constants/vending";

// Meter-ID card that opens the checkout sheet. Shared by the main hero and the pay. hero.
export default function BuyElectricityCard({ onMeterChange, className = "max-w-[520px]" }) {
  const [meterId, setMeterId] = React.useState("");
  const [error, setError] = React.useState("");
  const [open, setOpen] = React.useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!meterId.trim()) {
      setError("Please enter your meter Id");
      return;
    }
    setError("");
    setOpen(true);
  };

  return (
    <>
      <form
        onSubmit={onSubmit}
        className={`w-full rounded-3xl border border-black/5 bg-white p-4 shadow-[0_20px_50px_-20px_rgba(1,6,35,0.25)] ${className}`}
      >
        <label htmlFor="meter-id" className="mb-2 block px-1 text-sm font-semibold text-primary-dark">
          Buy electricity
        </label>
        <div className="flex flex-col gap-3 sm:flex-row">
          <div
            className={`flex flex-1 items-center gap-3 rounded-2xl bg-[#F3F3F7] px-4 ring-2 transition ${
              error ? "ring-red-400" : "ring-transparent focus-within:ring-primary-light/40"
            }`}
          >
            <AiOutlineBarcode className="text-xl text-primary-dark" />
            <input
              id="meter-id"
              type="number"
              inputMode="numeric"
              value={meterId}
              onChange={(e) => {
                setMeterId(e.target.value);
                setError("");
                onMeterChange?.(e.target.value);
              }}
              placeholder="Enter your meter Id"
              className="h-[54px] w-full bg-transparent text-base outline-none placeholder:text-[#9AA0B4]"
            />
          </div>
          <button
            type="submit"
            className="group inline-flex h-[54px] items-center justify-center gap-2 rounded-2xl bg-primary-dark px-6 font-semibold text-white transition hover:bg-primary-light"
          >
            Buy Electricity
            <FiArrowRight className="transition group-hover:translate-x-0.5" />
          </button>
        </div>
        {error && <p className="mt-2 px-1 text-sm text-red-600">{error}</p>}
        <p className="mt-3 px-1 text-xs text-[#6C6F7F]">
          Minimum purchase{" "}
          <span className="font-semibold text-primary-dark">₦{MIN_AMOUNT.toLocaleString()}</span>
          {" "}· ₦{DEFAULT_CHARGES.toLocaleString()} transfer charge added
        </p>
      </form>
      {open && <OpenVendingModal meterId={meterId} onClose={() => setOpen(false)} />}
    </>
  );
}
